
export class LeadRawHtmlResponse {
  emailSubject: string;
  rawHtml: string;
  rawText: string;

  constructor(emailSubject: any, rawHtml: any, rawText: any) {
    this.emailSubject = emailSubject;
    this.rawHtml = rawHtml;
    this.rawText = rawText;
  }
}
